import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12.001 1.957a1 1 0 0 1 1 1v9.662l3.11-2.97a1 1 0 0 1 1.381 1.446l-4.8 4.585a1 1 0 0 1-1.382 0l-4.8-4.585a1 1 0 0 1 1.382-1.446l3.11 2.97V2.957a1 1 0 0 1 1-1Zm8.4 12.263a1 1 0 0 1 1 1v3.706c0 .824-.325 1.616-.906 2.202-.58.585-1.37.916-2.195.916H5.7c-.825 0-1.614-.33-2.195-.916a3.127 3.127 0 0 1-.905-2.202V15.22a1 1 0 1 1 2 0v3.706c0 .3.118.584.325.793.207.209.486.325.775.325h12.6c.29 0 .568-.116.775-.325.207-.209.325-.494.325-.793V15.22a1 1 0 0 1 1-1Z"
  />,
  'Download2'
)
